import axiosInstance from './AxiosInstance';
const userUrl = "api/user"
const employeeUrl = "api/employees"
const driverUrl = "api/drivers"

const searchUserUrl = "api/search_user"
const searchEmployeeUrl = "api/search_employees"
const searchDriverUrl = "api/search_drivers"

// ################## User ##################

export function getUserListApi(page, page_size, filters = {}, department = {}, role = {}) {
    const params = new URLSearchParams({
        page,
        page_size,
        ...filters,
        ...department,
        ...role,
    });
    return axiosInstance.get(`${userUrl}?${params.toString()}`);
}


export function getUserApi(id) {
    return axiosInstance.get(`${userUrl}/${id}`);
}

export function createUserApi(data) {
    return axiosInstance.post(userUrl, data);
}

export function updateUserApi(id, data) {
    return axiosInstance.put(`${userUrl}/${id}`, data);
}
export function blockUserApi(id, data) {
    return axiosInstance.patch(`${userUrl}/${id}`, data);
}

export function searchUserApi() {
    return axiosInstance.get(`${searchUserUrl}`);
}


// ################## Employee ###################################


export function getEmployeeListApi(filters = {}) {
    const params = new URLSearchParams({ ...filters });
    return axiosInstance.get(`${employeeUrl}?${params.toString()}`);
}

export function getEmployeeApi(id) {
    return axiosInstance.get(`${employeeUrl}/${id}`);
}
export function createEmployeeApi(data) {
    return axiosInstance.post(employeeUrl, data);
}
export function updateEmployeeApi(id, data) {
    return axiosInstance.put(`${employeeUrl}/${id}`, data);
}
export function blockEmployeeApi(id, data) {
    return axiosInstance.patch(`${employeeUrl}/${id}`, data);
}
export function searchEmployeeApi() {
    return axiosInstance.get(`${searchEmployeeUrl}`);
}
// ################## Driver ##################

export function getDriverListApi(filters = {}) {
    const params = new URLSearchParams({ ...filters });
    return axiosInstance.get(`${driverUrl}?${params.toString()}`);
}

export function getDriverApi(id) {
    return axiosInstance.get(`${driverUrl}/${id}`);
}

export function createDriverApi(data) {
    return axiosInstance.post(driverUrl, data);
}

export function updateDriverApi(id, data) {
    return axiosInstance.put(`${driverUrl}/${id}`, data);
}

export function blockDriverApi(id, data) {
    return axiosInstance.patch(`${driverUrl}/${id}`, data);
}

export function searchDriverApi() {
    return axiosInstance.get(`${searchDriverUrl}`);
}
export function driverridinghistory(filter = {}, id) {
  const fparam = new URLSearchParams(filter).toString();
  return axiosInstance.get(`api/transport/driver_riding_history/${id}?${fparam}`);
}



























